<script>import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
import { twMerge } from 'tailwind-merge';
const forwardEvents = forwardEventsBuilder(get_current_component());
const defaultClass = 'connector absolute top-4 left-4 -ml-px h-full w-0.5 bg-border stwui-feed-item-connector';
$: finalClass = twMerge(defaultClass, $$props.cass);
</script>

<span
	class={finalClass}
	use:useActions={use}
	use:forwardEvents
	{...exclude($$props, ['use', 'class'])}
/>
